
import { clearUserScopedCaches } from '../../mtska-frontend-app-component/utils/cacheTtl';

export const handleSuccess = (response) => {

    return Promise.resolve(response.data)

}

export const handleError = (error) => {

    if (error?.response?.status === 401) {
        localStorage.removeItem('token');
        clearUserScopedCaches();
        window.location.reload(true);
    }
    if (error?.response?.status === 403) {
        return Promise.reject(error?.response?.data ?? error)
    }
    return Promise.reject(error?.response?.data ?? error)
}

